import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../../components/bannerfrom";

function Banner(props) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="ERP">
                <h1>
                  ERP Software Development Company USA - Hire ERP Developer
                </h1>
              </div>
              <div className="banner_content">
                <p>
                  Achieve 90% high-end process automation with our advanced ERP
                  software development, ensuring streamlined efficiency and
                  improved productivity for your business.
                </p>
                <p>
                  Our ERP developers include features such as push alerts,
                  user-friendly interfaces, reporting and analytics tools, and
                  more in apps for smartphones and tablets.
                </p>
                <p>
                  We offer custom ERP software development services that deliver
                  end-to-end solutions, empowering businesses to smoothly manage
                  and automate day-to-day operations while minimizing
                  operational risks with accuracy and reliability.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto ms-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
